import "../../style/mobile/dashboard/M_DateBox.css";

import { VscCircleFilled } from "react-icons/vsc";

import moment from "jalali-moment";
import { useState } from "react";

var today = new Date();

let m = moment();
// -------get-date--------------------
let date = m.jDate();
//----------get-day-------------------
let day = m.jDay();
//create-week---------------------------
let date_list;
let active_list;
switch (day) {
  case 0:
    date_list = [
      date,
      date + 1,
      date + 2,
      date + 3,
      date + 4,
      date + 5,
      date + 6,
    ];
    active_list = [1, 0, 0, 0, 0, 0, 0];
    break;
  case 1:
    date_list = [
      date - 1,
      date,
      date + 1,
      date + 2,
      date + 3,
      date + 4,
      date + 5,
    ];
    active_list = [0, 1, 0, 0, 0, 0, 0];
    break;
  case 2:
    date_list = [
      date - 2,
      date - 1,
      date,
      date + 1,
      date + 2,
      date + 3,
      date + 4,
    ];
    active_list = [0, 0, 1, 0, 0, 0, 0];
    break;
  case 3:
    date_list = [
      date - 3,
      date - 2,
      date - 1,
      date,
      date + 1,
      date + 2,
      date + 3,
    ];
    active_list = [0, 0, 0, 1, 0, 0, 0];
    break;
  case 4:
    date_list = [
      date - 4,
      date - 3,
      date - 2,
      date - 1,
      date,
      date + 1,
      date + 2,
    ];
    active_list = [0, 0, 0, 0, 1, 0, 0];
    break;
  case 5:
    date_list = [
      date - 5,
      date - 4,
      date - 3,
      date - 2,
      date - 1,
      date,
      date + 1,
    ];
    active_list = [0, 0, 0, 0, 0, 1, 0];
    break;
  case 6:
    date_list = [
      date - 6,
      date - 5,
      date - 4,
      date - 3,
      date - 2,
      date - 1,
      date,
    ];
    active_list = [0, 0, 0, 0, 0, 0, 1];
    break;
  default:
    date_list = [1, 2, 3, 4, 5, 6, 7];
    active_list = [1, 0, 0, 0, 0, 0, 0];
    break;
}

let week_list = [
  {
    id: 1,
    weekday: "شنبه",
    date: date_list[0],
    isActive: active_list[0],
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
  },
  {
    id: 2,
    weekday: "یکشنبه",
    date: date_list[1],
    isActive: active_list[1],
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
  },
  {
    id: 3,
    weekday: "دوشنبه",
    date: date_list[2],
    isActive: active_list[2],
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
  },
  {
    id: 4,
    weekday: "سه‌شنبه",
    date: date_list[3],
    isActive: active_list[3],
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
  },
  {
    id: 5,
    weekday: "چهارشنبه",
    date: date_list[4],
    isActive: active_list[4],
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
  },
  {
    id: 6,
    weekday: "پنجشنبه",
    date: date_list[5],
    isActive: active_list[5],
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
  },
  {
    id: 7,
    weekday: "جمعه",
    date: date_list[6],
    isActive: active_list[6],
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
  },
];

const M_DateBox = () => {
  // ---get-year----------------
  let year = m.jYear();
  // ------get---month---------
  let monthNum = m.jMonth() + 1;
  let month;
  switch (monthNum) {
    case 1:
      month = "فروردین";
      break;
    case 2:
      month = "اردیبهشت";
      break;
    case 3:
      month = "خرداد";
      break;
    case 4:
      month = "تیر";
      break;
    case 5:
      month = "مرداد";
      break;
    case 6:
      month = "شهریور";
      break;
    case 7:
      month = "مهر";
      break;
    case 8:
      month = "آبان";
      break;
    case 9:
      month = "آذر";
      break;
    case 10:
      month = "دی";
      break;
    case 11:
      month = "بهمن";
      break;
    case 12:
      month = "اسفند";
      break;
    default:
      month = "فروردین";
      break;
  }

  // const SetTime =()=>{
  //   setTimeout(()=>{
  //     setTimeout(today.getHours() + ":" + today.getMinutes());
  //   },1000);
  //   SetTime();
  //   // console.log("tic");
  // }

  const [time] = useState(today.getHours() + ":" + today.getMinutes());

  // setTimeout();

  return (
    <div className="m-date-box">
      <div className="m-date-box-p1">
        <div className="m-date-box-p1-year-and-month">
          <div className="m-dbp1-month">{month}</div>،
          <div className="m-dbp1-year">{year}</div>
        </div>
        <div className="m-date-box-p1-time">
          <VscCircleFilled className="m-dbp1t-circle-icon" />
          ساعت{time}
        </div>
      </div>
      <div className="m-date-box-p2">
        {week_list.map((item) => (
          <div key={item.id} className="m-date-box-p2-item">
            <div
              style={item.isActive ? { color: "#013273" } : null}
              className="m-dbp2i-dayname"
            >
              {item.weekday}
            </div>
            <div
              style={item.isActive ? item.style : null}
              className="m-dbp2i-date"
            >
              {item.date}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default M_DateBox;
